"use client"

import { t } from "@/languages/i18n"
import { DatePicker, Skeleton, Space, Typography } from "antd"
import dayjs from "dayjs"
import React from "react"

const { Text } = Typography

interface ScheduledProps {
  status: string
  publishDate: string | null
  setPublishDate: (date: string | null) => void
  isLoading?: boolean
}

/**
 * Schedule picker — redesigned: no own card chrome / title / collapse.
 * Sits as a plain block inside the parent FormSection's Xuất bản group.
 */
const Scheduled: React.FC<ScheduledProps> = ({ status, publishDate, setPublishDate, isLoading = false }) => {
  if (status !== "Draft") return null

  return (
    <div className="mt-3">
      <Text
        className="block mb-2"
        style={{ fontSize: 13, fontWeight: 500, color: "var(--admin-foreground)" }}
      >
        {t("Lịch đăng bài")}
      </Text>
      {isLoading ? (
        <Space direction="vertical" className="w-full">
          <Skeleton.Input active size="small" block />
        </Space>
      ) : (
        <>
          <DatePicker
            showTime
            className="w-full"
            format="YYYY-MM-DD HH:mm"
            placeholder={t("Chọn ngày giờ đăng")}
            value={publishDate ? dayjs(publishDate) : null}
            onChange={date => {
              setPublishDate(date ? date.toISOString() : null)
            }}
            disabledDate={current => current && current < dayjs().startOf("day")}
          />
          <Text
            type="secondary"
            className="block mt-1"
            style={{ fontSize: 12, color: "var(--admin-muted-fg)" }}
          >
            {publishDate
              ? `${t("Lịch đăng dự kiến:")} ${dayjs(publishDate).format("DD/MM/YYYY HH:mm")}`
              : t("Hệ thống sẽ tự động đăng vào thời điểm đã chọn.")}
          </Text>
        </>
      )}
    </div>
  )
}

export default Scheduled
